import { gql } from '@grandvisionhq/graphql';

var AppointmentFragment = gql`
  fragment AppointmentFragment on Appointment {
    id
    invitee {
      firstName
      lastName
      email
      phone
    }
    child {
      firstName
      lastName
    }
    appointmentType {
      id
      name
      label
      description
      ageGroup
      duration {
        amount
        unit
      }
    }
    startTime
    endTime
    isCancellable
    isReschedulable
    isReservation
    storeInfo {
      streetName
      streetNumber
      town
      name
      code
      phone
      postalCode
      country
      lat
      lon
    }
    customerComment
  }
`;

export { AppointmentFragment as default };
//# sourceMappingURL=appointment.js.map
